import React from 'react';
import { compose } from 'redux';

import withLanding from 'containers/Landing/withLanding';
import { pages as PAGES } from 'containers/Landing/constants';
import Hero from 'components/Hero';
import { withContent } from 'components/Content';
import OurServices from 'components/OurServices';
import Divider from 'components/Ui/Divider';
import DeliveryFlow from 'components/DeliveryFlow';
import Gulch from 'components/Gulch';
import Backgrounder from 'components/Backgrounder';
import Dispensers from 'components/Dispensers';
import WaterTypes from '../WaterTypes';

import styles from './resi.scss';

const CONTENT_KEYS = {
  hero: 'Hero',
  waterTypes: 'Water Types',
  services: 'Our Services',
  dispensers: 'Dispensers',
  deliveryFlow: 'Delivery Flow',
};

const Residential = ({ content }) => {
  return (
    <div className={styles.resi}>
      <Hero content={content.hero} />
      <OurServices className={styles.ourServices} content={content.services} />
      <Gulch />
      <WaterTypes content={content.waterTypes} />
      <Divider className={styles.divider} />
      <Dispensers content={content.dispensers} />
      <Divider className={styles.divider} />
      <Backgrounder>
        <DeliveryFlow
          content={content.deliveryFlow}
          className={styles.deliveryFlow}
        />
      </Backgrounder>
    </div>
  );
};

export default compose(
  withLanding(PAGES.residentialServices),
  withContent(CONTENT_KEYS),
)(Residential);
